import React, { useState } from 'react';

import { useDispatch } from 'react-redux';
import { Picker } from 'emoji-mart';

import { useUpdateMessageMutation } from '@school_ify/schoolify-repository/src/shared/types';

import { updateMessage, updateReplies } from 'redux/chat/actions';
import emojiIcon from 'assets/icons/emoji.svg';

import '../Messages/Messages.scoped.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  handleEdit?: (e: any) => void;
  isEmojiOpen: boolean;
  setIsEmojiOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleEmoji: (emoji: any) => void;
  activeMessage: {
    body: string;
    chat_id: string;
    created_at: string;
    id: string;
    is_pinned: boolean;
    user: {
      first_name: string;
      last_name: string;
    };
    user_id: string;
  };
  setActiveMessage: React.Dispatch<
    React.SetStateAction<{
      body: string;
      chat_id: string;
      created_at: string;
      id: string;
      is_pinned: boolean;
      user: {
        first_name: string;
        last_name: string;
      };
      user_id: string;
    }>
  >;
  value: string;
  setIsOnEdit: React.Dispatch<React.SetStateAction<boolean>>;
  setResClicked: React.Dispatch<
    React.SetStateAction<{
      id: any;
    }>
  >;
}

const EditMessageForm: React.FC<Props> = ({
  isEmojiOpen,
  setIsEmojiOpen,
  handleEmoji,
  setActiveMessage,
  activeMessage,
  value,
  setIsOnEdit,
  setResClicked,
}) => {
  const [body, setBody] = useState(value);
  const dispatch = useDispatch();
  const handleInput = e => {
    setBody(e.target.value);
  };

  const [updateMessageMutation] = useUpdateMessageMutation();

  const { t } = useTranslation('common');

  const handleEdit = e => {
    e.preventDefault();
    updateMessageMutation({
      variables: {
        id: activeMessage.id,
        body,
      },
    });
    setActiveMessage(prev => {
      return {
        ...prev,
        body,
      };
    });

    setActiveMessage({
      body: '',
      chat_id: '',
      created_at: '',
      id: '',
      is_pinned: false,
      user: {
        first_name: '',
        last_name: '',
      },
      user_id: '',
    });

    setIsOnEdit(true);
    dispatch(updateMessage({ id: activeMessage.id, body }));
    dispatch(updateReplies(activeMessage));
    setResClicked({ id: null });
  };
  return (
    <form onSubmit={handleEdit}>
      <div className="edit-container">
        <div className="emoji-dropdown">
          {isEmojiOpen && <Picker set="apple" onSelect={emoji => handleEmoji(emoji.native)} />}
        </div>
        <div className="icon emoji pointer">
          <img onClick={() => setIsEmojiOpen(!isEmojiOpen)} src={emojiIcon} alt="emoji icons" />
        </div>
        <input value={body} onChange={handleInput} autoFocus />

        <button
          className="close-button"
          type="button"
          onClick={() =>
            setActiveMessage({
              body: '',
              chat_id: '',
              created_at: '',
              id: '',
              is_pinned: false,
              user: {
                first_name: '',
                last_name: '',
              },
              user_id: '',
            })
          }
        >
          {t('cancel')}
        </button>
        <button className="edit-button">{t('save')}</button>
      </div>
    </form>
  );
};

export default EditMessageForm;
